import useSWR from "swr";
import Layout from "../../../components/custom/Layout";
import useUnit from "../../../customHooks/useUnit";
import useMonthYear from "../../../components/MonthYearPicker/useMonthYear";
import { customFetcher, extractReactTableData, fileDownload } from "../../../utils";
import { IPayment } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import MonthYearPicker from "../../../components/MonthYearPicker";
import { useRef } from "react";
import styled from "styled-components";
import ActionIcon from "../../../components/custom/ActionIcon";
import apiClient from "../../../apiClient";

export default function CargoPayments() {

    const unit = useUnit();
    const { month, setMonth, year, setYear } = useMonthYear();
    const runQuery = unit && month && year;
    const endpoint = runQuery ? `/cargo-payments?unit=${unit}&month=${month}&year=${year}` : null;
    const tableRef = useRef();

    const {
        data
    } = useSWR(endpoint, customFetcher<IPayment>, {
        shouldRetryOnError: (err) => {
            // Don't retry if it's a 429
            if (err?.response?.status === 429) {
                return false;
            }
            // Retry for all other errors
            return true;
        },
    });

    const handleDownload = () => {
        const data = extractReactTableData(tableRef, ['index']);
        fileDownload(data, `Cargo Payments`, true);
    }

    return (
        <Layout>
            <h1>Cargo Payments</h1>
            <FlexContainer>
                <MonthYearPicker
                    setMonth={setMonth}
                    setYear={setYear}
                />
                <ActionIcon
                    type={'download'}
                    onClick={handleDownload}
                />
            </FlexContainer>

            <VirtualTable<IPayment>
                data={data}
                mapping={[{
                    name: 'MAWB',
                    value: 's_awb',
                    s_mawb: true
                }, {
                    name: 'HAWB',
                    value: 's_hawb'
                }, {
                    name: 'Payment Method',
                    value: 's_payment_method'
                }, {
                    name: 'Payment Type',
                    value: 's_payment_type'
                }, {
                    name: 'Amount',
                    value: 'f_amount',
                    money: true
                }, {
                    name: 'Name',
                    value: 's_name'
                }, {
                    name: 'Notification Email',
                    value: 's_notification_email'
                }, {
                    name: 'Created',
                    value: 't_created',
                    datetime: true,
                    utc: true
                }]}
                reactTableRef={tableRef}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;